import { render, staticRenderFns } from "./ForwardRepair.vue?vue&type=template&id=42d1422f&scoped=true&"
import script from "./ForwardRepair.vue?vue&type=script&lang=ts&"
export * from "./ForwardRepair.vue?vue&type=script&lang=ts&"
import style0 from "./ForwardRepair.vue?vue&type=style&index=0&id=42d1422f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1422f",
  null
  
)

export default component.exports